// src/contexts/explicit-subscription-counts.ts
/**
* Explicit websocket subscriptions are connection-wide, but several mounted
* views can want the same event. The first view to unmount must not send
* `unsubscribe::` while another view is still listening.
*
* `subscribe` / `unsubscribe` return true when the caller should send the
* matching wire message.
*/
function createExplicitSubscriptionCounts() {
	const counts = /* @__PURE__ */ new Map();
	return {
		clear() {
			counts.clear();
		},
		events() {
			return Array.from(counts.keys());
		},
		subscribe(event) {
			const next = (counts.get(event) ?? 0) + 1;
			counts.set(event, next);
			return next === 1;
		},
		unsubscribe(event) {
			const current = counts.get(event) ?? 0;
			if (current === 0) return false;
			if (current === 1) {
				counts.delete(event);
				return true;
			}
			counts.set(event, current - 1);
			return false;
		}
	};
}
export { createExplicitSubscriptionCounts };

//# sourceMappingURL=explicit-subscription-counts.js.map